var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalmartLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "534px",
    height: "599.5px",
    viewBox: "0 0 534 599.5",
    style: {
      enableBackground: "new 0 0 612 792"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007DC3;}\n\t.st1{fill:#FDBB30;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.777778, 0, 0, 1.777778, -32.000004, -502.720032)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 168.167 396.322 C 176.065 396.322 182.548 392.198 183.418 386.883 L 191.218 298.652 C 191.218 289.933 181.033 282.78 168.167 282.78 C 155.324 282.78 145.14 289.933 145.14 298.652 L 152.939 386.883 C 153.784 392.198 160.292 396.322 168.167 396.322"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 120.474 423.87 C 124.424 417.063 124.125 409.338 119.952 405.935 L 47.445 355.088 C 39.918 350.717 28.592 355.982 22.183 367.086 C 15.775 378.214 16.892 390.61 24.419 394.956 L 104.675 432.315 C 109.718 434.177 116.525 430.626 120.498 423.771"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 215.858 423.795 C 219.807 430.651 226.639 434.203 231.631 432.34 L 311.938 394.981 C 319.489 390.61 320.607 378.214 314.173 367.11 C 307.765 355.982 296.414 350.741 288.911 355.113 L 216.405 405.96 C 212.256 409.363 211.958 417.088 215.883 423.894"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 168.167 506.511 C 176.065 506.511 182.548 510.585 183.418 515.875 L 191.218 604.081 C 191.218 612.824 181.033 619.979 168.167 619.979 C 155.324 619.979 145.14 612.824 145.14 604.081 L 152.939 515.875 C 153.784 510.585 160.292 506.511 168.167 506.511"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 215.858 478.964 C 219.807 472.108 226.639 468.556 231.631 470.419 L 311.938 507.753 C 319.489 512.149 320.607 524.545 314.173 535.673 C 307.765 546.776 296.414 552.042 288.911 547.671 L 216.405 496.874 C 212.256 493.445 211.958 485.745 215.883 478.915"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 120.474 478.915 C 124.424 485.77 124.125 493.445 119.952 496.874 L 47.445 547.695 C 39.918 552.042 28.592 546.776 22.183 535.698 C 15.775 524.57 16.892 512.149 24.419 507.753 L 104.675 470.443 C 109.718 468.531 116.525 472.108 120.498 478.939"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmartLogo);
export default __webpack_public_path__ + "static/media/walmart-logo.126113e07af49da87a10911f06f2e0ab.svg";
export { ForwardRef as ReactComponent };